export default [
  {
    title: 'Dander',
    text: 'Dander is dead skin cells. The average person sheds about 600,000 skin cells per day.',
    img: '/testing/dander.jpg',
    credit: 'Dariusz Sankowski'
  },
  {
    title: 'Cellulose Fibers',
    text: 'Cellulose fibers are natural fibers from plant material',
    img: '/testing/cellulose.jpg',
    credit: 'Okram CC BY-SA 3.0'
  },
  {
    title: 'Synthetic Fibers',
    text: 'Synthetic fibers are man-made fibers such as nylon, polyester, and polyolefin',
    img: '/testing/synthetic.jpg',
    credit: 'Vader1941 CC BY-SA 4.0'
  },
  {
    title: 'Fiberglass Fibers',
    text: 'Fiberglass Glass or Glass wool is an insulating material made from fibers of glass arranged using a binder into a texture similar to wool. The process traps many small pockets of air between the glass, and these small air pockets result in the thermal insulation properties.',
    img: '/testing/fiberglass.jpg',
    credit: 'Gabriela P. CC BY 4.0'
  },
  {
    title: 'Animal Hair',
    text: 'Hair from any animal. They are easily distinguished from human hair.',
    img: '/testing/animalhair.jpg',
    credit: 'Sunny Ripert CC BY-SA 2.0'
  },
  {
    title: 'Plant Hair',
    text: 'Hairs or pieces from plant material.',
    img: '/testing/planthair.jpg',
    credit: 'Jerome Prohaska CC BY-SA 3.0'
  },
  {
    title: 'Human Hair',
    text: 'Human hairs or pieces of hair',
    img: '/testing/humanhair.png',
    credit: 'Guillaume Paumier CC BY-SA 3.0'
  },
  {
    title: 'Insect Parts',
    text: 'Pieces of insects such as arms, wings, antennae, etc.',
    img: '/testing/insectparts.jpg',
    credit: 'Josef Reischig CC BY-SA 3.0'
  },
  {
    title: 'Feather Barbules',
    text: 'Any individual parts that make up a feather',
    img: '/testing/feather.jpg',
    credit: 'Josef Reischig CC BY-SA 3.0'
  },
  {
    title: 'Pollen',
    text: 'Reproductive structures of trees, grasses, and plants',
    img: '/testing/pollen.jpg',
    credit: 'Dartmouth College'
  },
  {
    title: 'Gypsum',
    text: 'Drywall (also known as plasterboard, wallboard, or gypsum board) is a panel made of gypsum plaster pressed between two thick sheets of paper.',
    img: '/testing/gypsum.jpg',
    credit: 'James Petts CC BY-SA 2.0'
  },
  {
    title: 'Talc',
    text: 'Talc is a mineral composed of hydrated magnesium silicate',
    img: '/testing/talc.jpg',
    credit: 'Pelex CC BY-SA 3.0'
  },
  {
    title: 'Silicates',
    text: 'Silicates comprise the majority of the Earth\'s crust. Sand, Portland cement, and thousands of minerals are examples of silicates',
    img: '/testing/silicate.jpg',
    credit: '	Chemicalinterest'
  },
  {
    title: 'Ash-like Soot',
    text: 'Ash-like soot is formed from the combustion of wood products.',
    img: '/testing/soot.jpg',
    credit: 'Rasbak CC BY-SA 3.0'
  }
]